import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 8L10 13L15 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronDown;
